import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./services/authInterceptor";
import MidOfficePagesIntegration from "./MidOffice_MO/pages/MidOfficePagesIntegration";
// import MoSidebar from "./MidOffice_MO/Sidebar/MoSidebar";
// import MoHeader from "./MidOffice_MO/Header/MoHeader";
// import ViewDocument from "./BackOffice_BO/components/viewDocument"; // Changed to uppercase
// import RejectApplicationModal from "./BackOffice_BO/components/RejectApplicationModal";
// import PaymentStatusModal from "./BackOffice_BO/components/PaymentStatusModal";
// import OpenDocumentModal from "./BackOffice_BO/components/OpenDocumentModal";
// import ConfromationModal from "./BackOffice_BO/components/ConfromationModal";
import BackOfficePagesIntegration from "./BackOffice_BO/pages/BackOfficePagesIntegration";
//import VendorLoginform from "./Login/Loginform";
import NewVendorlLogin from "./landingPage/NewVendorlLogin";
import { ToastProvider } from "./mesageToast/ToastContainer";
import PrivateRoute from "./protectedRoutes/PrivateRoute";
//import OrderPageIntegration from "./MidOffice_MO/orders/OrderPageIntegration";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <OrderPageIntegration /> */}

        <ToastProvider>
          <Routes>
            <Route path="/" element={<NewVendorlLogin />} />
            <Route
              // path="/MOD/*"
              element={<PrivateRoute allowedRole={"mid-office"} />}
            >
              <Route path="/MOD/*" element={<MidOfficePagesIntegration />} />
            </Route>
            <Route
              // path="/BOD/*"
              element={<PrivateRoute allowedRole={"back-office"} />}
            >
              <Route path="/BOD/*" element={<BackOfficePagesIntegration />} />
            </Route>
          </Routes>
        </ToastProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
